import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Container, Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TAGTypography, TAGSvgIcon } from '../../elements';
import TAGAgendaStepper from '../../elements/TAGSteppers/TAGAgendaStepper';
import RichText from '../RichText';
import * as templates from '../../templates';
export var AgendaStepper = function AgendaStepper(_ref) {
  var description = _ref.description,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'neutral' : _ref$backgroundColor,
      title = _ref.title,
      _ref$hideStepperDot = _ref.hideStepperDot,
      hideStepperDot = _ref$hideStepperDot === void 0 ? false : _ref$hideStepperDot,
      icon = _ref.icon,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      sx = _ref.sx;
  var theme = useTheme();
  var isSmallDevice = useMediaQuery(theme.breakpoints.down(1024));
  var stepFontSwitch = useMediaQuery(theme.breakpoints.down(1201));
  var isFullWidth = fullWidth ? {
    headingWidth: isSmallDevice ? 10 : 12,
    bodyWidth: isSmallDevice ? 10 : 7
  } : {
    headingWidth: 12,
    bodyWidth: 9
  };
  var isMobile = isSmallDevice && fullWidth ? {
    stepLineHeight: '',
    orientation: 'vertical',
    iconDisplay: hideStepperDot ? true : false,
    bodyFontSize: '18px',
    bodyLineHeight: '28px',
    stepperPosition: hideStepperDot ? 'flex-start' : 'center',
    verticalStepperPadding: hideStepperDot ? '40px' : 'none'
  } : {
    stepLineHeight: stepFontSwitch ? '20px' : '24px',
    orientation: 'horizontal',
    iconDisplay: true,
    bodyFontSize: '22px',
    bodyLineHeight: '36px',
    stepperPosition: 'center',
    verticalStepperPadding: 'none'
  };
  var copyOfSteps = steps.map(function (step, index) {
    var _step$bodyText;

    return _objectSpread(_objectSpread({}, step), {}, {
      bodyText: ((_step$bodyText = step.bodyText) === null || _step$bodyText === void 0 ? void 0 : _step$bodyText.__typename) && templates[step.bodyText.__typename.slice(10)] && React.createElement(templates[step.bodyText.__typename.slice(10)], _objectSpread(_objectSpread({}, step.bodyText), {}, {
        branding: 'aspendental',
        key: "".concat(step.bodyText.contentful_id, "-stepcontent").concat(index)
      }))
    });
  });
  var children = React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "center",
    direction: "column",
    sx: [{
      backgroundColor: "backgrounds.".concat(backgroundColor),
      pt: 3,
      pb: 6
    }, sx],
    rowSpacing: 3
  }, icon && React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGSvgIcon, {
    icon: "".concat(icon),
    size: 64
  }))), title && React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "center"
  }, React.createElement(Grid, {
    item: true,
    xs: isFullWidth.headingWidth,
    textAlign: "center"
  }, React.createElement(TAGTypography, {
    fontStyle: "h1",
    color: "primary.main"
  }, title))), description && React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: "center"
  }, React.createElement(Grid, {
    item: true,
    xs: isFullWidth.bodyWidth,
    alignItems: "center",
    justifyContent: 'center',
    sx: {
      '.MuiContainer-root': {
        p: {
          textAlign: 'center',
          '.MuiTypography-root': {
            fontSize: isMobile.bodyFontSize,
            lineHeight: isMobile.bodyLineHeight
          }
        }
      }
    }
  }, React.createElement(RichText, {
    branding: "aspendental",
    content: description.content,
    backgroundColor: description.backgroundColor
  }))), steps && React.createElement(Grid, {
    item: true,
    container: true,
    justifyContent: isMobile.stepperPosition,
    sx: {
      pl: isMobile.verticalStepperPadding
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGAgendaStepper, {
    steps: copyOfSteps,
    stepFontSize: stepFontSwitch ? '14px' : '16px',
    stepIconColor: 'success.main',
    stepLineHeight: stepFontSwitch ? '20px' : '24px',
    horizontalLineMargin: 6,
    iconDisplay: isMobile.iconDisplay,
    iconSize: 12,
    orientation: isMobile.orientation,
    verticalLineMargin: hideStepperDot ? 5 : 'auto',
    verticalLinePadding: 8
  }))));
  return fullWidth ? children : React.createElement(Container, {
    sx: [sx]
  }, children);
};
export default AgendaStepper;